<template>
  <div>
    <sale-plan-list v-show="action === 'list'" @change-action="changeAction" />
    <sale-plan-detail v-if="action === 'detail'" :plan-num="planNum" @change-action="changeAction" />
  </div>
</template>

<script>
import SalePlanList from './components/SalePlanList.vue'
import SalePlanDetail from './components/SalePlanDetail.vue'
export default {
  components: {
    SalePlanList,
    SalePlanDetail
  },
  data() {
    return {
      action: 'list',
      planNum: ''
    }
  },
  created() {
    const { action, planNum } = this.$route.query
    if (action && planNum) {
      this.action = action
      this.planNum = planNum
    }
  },
  methods: {
    changeAction(type, planNum) {
      this.action = type
      this.planNum = planNum || ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanTotalList.vue